module.exports = __webpack_public_path__ + "static/During Work - 5-1845a78f391af600a14783000daac814.jpg";